<template>
    <div>
        <div :class="{ 'warningDiv': showSessionWarning,'hide-warningDiv': !showSessionWarning  }">
            <h2>Session Timeout Warning</h2>
            <p>Your session will expire in: {{ countdownFormatted }}</p>
            <button @click="refreshSession">Continue</button>
            <button @click="endSession">Log Out</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MHISessionTimeout",
        data() {
            return {
                sessionTimeout: 20 * 60,
                countdown: 60,
                showSessionWarning: false,
                countdownIntervalId: null,
            };
        },
        computed: {
            countdownFormatted() {
                const minutes = Math.floor(this.countdown / 60);
                const seconds = this.countdown % 60;
                return `${minutes} minute${minutes === 1 ? '' : 's'} ${seconds} second${seconds === 1 ? '' : 's'}`;
            }
        },
        methods: {
            endSession() {
                this.$window.location.href = "/portal";
            },
            displayCountdown() {
                this.countdownIntervalId = setInterval(() => {
                    if (this.countdown === 0) {
                        this.endSession();
                        return;
                    }
                    this.countdown--;
                }, 1000);
            },
            promptToExtendSession() {
                this.showSessionWarning = true;
                this.displayCountdown();
            },
            refreshSession() {
                clearInterval(this.countdownIntervalId);
                this.$api.user.extendSession();
                this.showSessionWarning = false;
                this.startSessionManager();
            },
            startSessionManager() {
                setTimeout(() => {
                    this.promptToExtendSession();
                }, (this.sessionTimeout - this.countdown) * 1000);
            }
        },
        mounted() {
            this.startSessionManager();
        }
    };
</script>
<style scoped>
    .hide-warningDiv {
        display: none;
    }

    .warningDiv {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        border: 1px solid #ccc;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        padding: 20px;
        width: 450px;
        z-index: 1000;
    }

        .warningDiv h2 {
            font-size: 1.5em;
            margin-bottom: 10px;
        }

        .warningDiv p {
            font-size: 1.2em;
        }

        .warningDiv button {
            background-color: #007acc;
            color: #fff;
            padding: 10px 20px;
            border: none;
            margin-right: 10px;
            cursor: pointer;
        }

            .warningDiv button:hover {
                background-color: #005f9d;
            }
</style>